module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_c('strong', [_vm._v("The Motors Set-list:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Phoney Heaven, Whiskey and Wine, Bring on the Morning Light, Emergency, You Beat the Hell Outta Me, Summertime (Is Calling), Cold Love, Sensation, Be What You Gotta Be, Freeze. Dancing the Night Away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "Center"
    }
  }, [_c('strong', [_c('br'), _vm._v("My favourite top ten Motors songs:")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Dancing the Night Away")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("That’s What John Said")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Airport")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Phoney Heaven")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Emergency")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Forget About You")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Freeze")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Love and Loneliness")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Be What You Gotta Be")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Day I Found a Fiver")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39322c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 78
// module chunks = 0